import type { CurrencyAddress } from './CurrencyAddress'
import type { Equivalence } from '@blade/std-lib'
import type { Network } from '@root/entities/network/model'

export interface Ref {
  address: CurrencyAddress
  network: Network.Network
}

export const eq: Equivalence.Equivalence<Ref> = (left, right) =>
  left.address === right.address && left.network === right.network

export const toString = (value: Ref) => `${value.network}:${value.address}`
